// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error_content{align-items:center;text-align:center;min-width:50%}.error_content button svg{margin-right:5px}.errorBtnContainer button svg{color:#fff !important;display:unset !important;margin-top:0 !important}.errorBtnContainer button span{padding-left:5px}", ""]);
// Exports
module.exports = exports;
